import React from 'react';
import './CardsContainer.css';
import ImageCard from "../card/ImageCard"

const CardsContainer = () => {
  const cardData = [
    {
      title: "Tracker",
      description: "How are VC-backed startups faring in the public markets? Which cos have gained the most? ",
      link: "https://www.ventureintelligence.com/ipo-tracker/",
      linkText: "Learn More →",
      ds_link: "/ipo-tracker",
    },
    {
      title: "Insights",
      description: "No. of Unicorn Startups in India Has Crossed 100 - View the Full List",
      link: "https://blog.ventureintelligence.com/",
      linkText: "Learn More →",
      ds_link: "/Indian-Unicorn-Tracker",
    },
    {
      title: "Reports",
      description: "Indian AI and Deep Tech Investments Landscape Report - 2026",
      link: "https://www.ventureintelligence.com/india-ai-deeptech-investments-landscape-report-2026",
      linkText: "Learn More →",
      ds_link: "/india-ai-deeptech-investments-landscape-report-2026",
    },
    {
      title: "Press Release",
      description: "Only 1 in 4 startups graduates from Seed to Series A: Report",
      link: "/Press-Release",
      linkText: "Learn More →",
      ds_link: "https://ventureintelligence.blogspot.com/2024/10/only-1-in-4-startups-graduates-from.html",
    },
    {
      title: "Media Coverage",
      description:
        "Venture Money Floods Into Indian Startups - Wall Street Journal (quoting Venture Intelligence data)",
      link: "https://www.google.co.in/search?hl=en&rls=org.mozilla:en-US:official&q=%22Venture+Intelligence%22&um=1&tbs=nws:1&tab=wn&ei=fDsuVYeBOou3uQSs4IDQAg",
      ds_link: "https://www.wsj.com/articles/venture-money-floods-into-indian-startups-1427748367",
      linkText: "Learn More →",
    },
    {
      title: "Events",
      description: "PE-VC Conclave - Mumbai (Oct 29)",
      link: "/Events",
      ds_link: "https://events.ventureintelligence.com/conclave26-mumbai-recap/",
      linkText: "Learn More →",
    },
  ]

  return (
    <div className="cards-container-wrapper">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full  mx-auto justify-items-center mt-4">
        {cardData.map((card, index) => (
          <ImageCard key={index} {...card} />
        ))}
      </div>
    </div>
  )
}

export default CardsContainer